import React from 'react';
import { CurricularClass72023 } from 'views/CurricularClass52023/components';

const ExtraCurricularActivitiesPage = () => {
  return <CurricularClass72023 />;
};

export default ExtraCurricularActivitiesPage;
